import { render, staticRenderFns } from "./DocumentNameIndexing.vue?vue&type=template&id=4fb4d806&scoped=true&"
import script from "./DocumentNameIndexing.vue?vue&type=script&lang=js&"
export * from "./DocumentNameIndexing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb4d806",
  null
  
)

export default component.exports